/* eslint-disable */
export default function(params) {
    return new Promise((resolve, reject) => {
        _getGroupNicheConfig({
            groupList: [
                {
                    groupName: '我的QQ群',
                    groupCode: params.ids
                }
            ],
            filter: 0
        }).then(
            res => {
                if (window.parseInt(res.code) === 0 && res.data && res.data.records && res.data.records.length) {
                    let hash = {}
                    res.data.records[0].groupList.map(x=>{
                        hash[x.uin] = {
                            ...x,
                            id: x.uin
                        }
                    })
                    resolve(hash);
                } else {
                    resolve({});
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
function _getGroupNicheConfig(params) {    
    return Vue.prototype.$_sAjax.post('/hb/selector/getTroopDetail', params);
}
